module.exports = __webpack_public_path__ + "static/media/instagram.0b117993.svg";